class AuweTheme {
  constructor() {
    this.drawer = document.querySelector('[data-cart-drawer]');
    this.bindNavigation();
    this.bindCart();
    this.bindProduct();
    this.loadRecommendations();
    this.bindKeyboard();
    document.documentElement.classList.remove('no-js');
  }

  bindNavigation() {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = document.querySelector('[data-menu-toggle]');
    const close = document.querySelector('[data-menu-close]');
    open?.addEventListener('click', () => {
      menu.hidden = false;
      open.setAttribute('aria-expanded', 'true');
      document.body.classList.add('no-scroll');
      this.activateFocusTrap(menu, close);
    });
    close?.addEventListener('click', () => {
      menu.hidden = true;
      open?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('no-scroll');
      this.releaseFocusTrap(open);
    });
  }

  bindCart() {
    document.addEventListener('click', async (event) => {
      const open = event.target.closest('[data-cart-open]');
      const close = event.target.closest('[data-cart-close]');
      const add = event.target.closest('[data-ajax-add]');
      const remove = event.target.closest('[data-cart-remove]');
      if (open) this.openCart();
      if (close || event.target.matches('[data-cart-overlay]')) this.closeCart();
      if (add) {
        event.preventDefault();
        const form = add.closest('form');
        if (!form) return;
        add.disabled = true;
        await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(Object.fromEntries(new FormData(form)))
        });
        add.disabled = false;
        await this.refreshCart();
        this.openCart();
      }
      if (remove) {
        await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: remove.dataset.cartRemove, quantity: 0 })
        });
        await this.refreshCart();
      }
    });
  }

  bindProduct() {
    document.addEventListener('click', (event) => {
      const minus = event.target.closest('[data-quantity-minus]');
      const plus = event.target.closest('[data-quantity-plus]');
      const media = event.target.closest('[data-product-media]');
      const lightboxClose = event.target.closest('[data-lightbox-close]');
      if (minus || plus) {
        const input = event.target.closest('.quantity')?.querySelector('input');
        if (!input) return;
        input.value = Math.max(1, Number(input.value || 1) + (plus ? 1 : -1));
      }
      if (media) {
        document.querySelectorAll('[data-product-media]').forEach((node) => node.classList.remove('is-active'));
        media.classList.add('is-active');
        const dialog = document.querySelector('[data-product-lightbox]');
        const image = dialog?.querySelector('[data-lightbox-image]');
        if (dialog && image && media.dataset.mediaSrc) {
          image.src = media.dataset.mediaSrc;
          image.alt = media.dataset.mediaAlt || '';
          dialog.showModal();
        }
      }
      if (lightboxClose) lightboxClose.closest('dialog')?.close();
    });
    document.querySelector('[data-variant-select]')?.addEventListener('change', (event) => {
      const option = event.target.selectedOptions[0];
      const price = document.querySelector('[data-product-price]');
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
    });
  }

  bindKeyboard() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const menu = document.querySelector('[data-mobile-menu]');
        if (menu && !menu.hidden) document.querySelector('[data-menu-close]')?.click();
        if (this.drawer && !this.drawer.hidden) this.closeCart();
      }
      if (event.key === 'Tab' && this.focusTrap) {
        const focusable = [...this.focusTrap.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((node) => !node.hidden);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
  }

  activateFocusTrap(container, initial) {
    this.focusTrap = container;
    this.previousFocus = document.activeElement;
    requestAnimationFrame(() => initial?.focus());
  }

  releaseFocusTrap(fallback) {
    this.focusTrap = null;
    (this.previousFocus || fallback)?.focus?.();
    this.previousFocus = null;
  }

  async loadRecommendations() {
    const container = document.querySelector('[data-product-recommendations]');
    if (!container?.dataset.url) return;
    const response = await fetch(container.dataset.url);
    if (!response.ok) return;
    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector('[data-product-recommendations]');
    if (next?.innerHTML.trim()) container.innerHTML = next.innerHTML;
  }

  openCart() {
    if (!this.drawer) return;
    clearTimeout(this.cartCloseTimer);
    this.drawer.hidden = false;
    requestAnimationFrame(() => this.drawer.classList.add('is-open'));
    document.body.classList.add('no-scroll');
    this.activateFocusTrap(this.drawer.querySelector('.cart-drawer__panel'), this.drawer.querySelector('[data-cart-close]'));
  }

  closeCart() {
    this.drawer?.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    this.releaseFocusTrap(document.querySelector('[data-cart-open]'));
    clearTimeout(this.cartCloseTimer);
    this.cartCloseTimer = setTimeout(() => { if (this.drawer) this.drawer.hidden = true; }, 250);
  }

  async refreshCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`);
    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const next = parsed.querySelector('[data-cart-drawer]');
    if (next && this.drawer) {
      this.drawer.innerHTML = next.innerHTML;
      this.drawer.dataset.cartCount = next.dataset.cartCount || '0';
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = next.dataset.cartCount || '0';
      });
    }
  }
}
document.addEventListener('DOMContentLoaded', () => new AuweTheme());
